import { Pipe, PipeTransform } from '@angular/core';
import { DigitalAgentInterface } from '@vendasta/task-manager';

@Pipe({
  name: 'digitalAgentName',
  standalone: false,
})
export class DigitalAgentNamePipe implements PipeTransform {
  transform(digitalAgent?: DigitalAgentInterface): string {
    return [digitalAgent?.firstName, digitalAgent?.lastName].filter(Boolean).join(' ');
  }
}
